<template>
  <pagefra>
    <div
      class="receiver fullscreen container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form :inline="true" v-model="form" class="toolbar-form">
            <el-form-item :label="$l('接收人')">
              <el-input
                v-model="form.receiver"
                maxlength="30"
                :placeholder="$l('接收人')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('手机号')">
              <el-input
                v-model="form.telNum"
                maxlength="30"
                :placeholder="$l('手机号')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd()"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <!-- <el-button icon="el-icon-refresh-right" round>重置</el-button> -->
            <el-button
              icon="el-icon-close"
              round
              @click="deleteReceiver"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
            <el-button
              round
              icon="el-icon-upload2"
              @click="openImportElevator()"
              v-if="hasPermission('导入电梯权限')"
            >
              {{ $l("导入电梯权限") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="receiver"
              :label="$l('接收人')"
              min-width="150"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              property="telNum"
              :label="$l('手机号')"
              min-width="120"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              property="createDate"
              :label="$l('创建时间')"
              min-width="180"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              property="creator"
              :label="$l('设置账号')"
              min-width="150"
              header-align="center"
              align="center"
              v-if="$store.state.user.roleType == 1"
            ></el-table-column>
            <el-table-column
              property="expired"
              :label="$l('账号是否有效')"
              min-width="100"
              header-align="center"
              align="center"
              v-if="$store.state.user.roleType == 1"
            ></el-table-column>
            <el-table-column
              property="remark"
              :label="$l('备注')"
              min-width="150"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              header-align="center"
              align="center"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                  v-if="$store.state.user.userId == scope.row.creatorId"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        ::title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        width="660px"
        @close="isLoadElevator = true"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          class="dialog-form"
        >
          <el-form-item :label="$l('接收人')" prop="receiver">
            <el-input v-model="editForm.receiver"></el-input>
          </el-form-item>
          <el-form-item :label="$l('手机号')" prop="telNum">
            <el-input v-model="editForm.telNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('备注')" prop="remark">
            <el-input
              type="textarea"
              :rows="5"
              v-model="editForm.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button round type="primary" @click="showBindElevator"
              >{{ $l("绑定电梯") }}
            </el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('绑定电梯')"
        :visible.sync="bindDialogVisible"
        width="940px"
        class="bindElevator"
        @close="closeBindElevatorDialog"
      >
        <el-form class="toolbar-form" :inline="true" v-model="form" label-width>
          <el-form-item :label="$l('地盘名称')">
            <el-input
              v-model="elevatorForm.domainName"
              :placeholder="$l('地盘名称')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('工号')">
            <el-input
              v-model="elevatorForm.jobNum"
              :placeholder="$l('工号')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              circle
              @click="searchElevator"
            ></el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="elevatorTable"
          highlight-current-row
          v-loading.lock="bindElevatorLoading"
          :data="tableElevatorData"
          max-height="300px"
          style="width: 100%; z-index: 1000"
          @select="selectElevator"
          @select-all="selectAllElevator"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            :label="$l('序号')"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            property="city"
            :label="$l('城市')"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="domainName"
            :label="$l('地盘')"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="buildingName"
            :label="$l('大楼名称')"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="elevatorNum"
            :label="$l('梯号')"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="jobNum"
            :label="$l('工号')"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="elevator.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="elevator.pageSize"
          :total="elevator.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
        <el-tabs>
          <el-tab-pane :label="$l('已选')">
            <div class="selectedElevator">
              <span v-for="(v, i) in jobNumList" :key="i">
                <el-tag type="success" closable @close="closeTag(v)">{{
                  v
                }}</el-tag>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button @click="clearSelectedElevator"
            >{{ $l("清 空") }}
          </el-button>
          <el-button @click="cancelBindElevator">{{ $l("取 消") }} </el-button>
          <el-button type="primary" @click="bindElevator"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$l('导入电梯权限')"
        :visible.sync="importElevatorDialogVisible"
        width="30%"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :limit="2"
          :file-list="fileList"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          list-type="text"
          :auto-upload="false"
        >
          <el-button size="small" round type="primary"
            >{{ $l("点击上传") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $l("只能上传xlsx文件") }}

            <a
              href="#"
              style="text-decoration: none"
              @click="downloadTemplate('电梯工号.xlsx')"
              >{{ $l("模板文件") }}
            </a>
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importElevatorDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="importElevator"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";

export default {
  name: "msg",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateReceiver = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入接收人")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入手机号")));
      } else if (
        value != null &&
        value.trim().length > 0 &&
        (isNaN(value) || value.indexOf(".")) >= 0
      ) {
        callback(new Error(this.$l("请输入数字!")));
      } else {
        callback();
      }
    };
    return {
      form: {
        receiver: "",
        telNum: "",
      },
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        receiverId: null,
        receiver: "",
        telNum: "",
        remark: "",
        jobNumList: null,
      },
      rules: {
        receiver: [
          { required: true, message: this.$l("请输入接收人"), trigger: "blur" },
          {
            max: 30,
            message: this.$l("长度不能超过 30 个字符"),
            trigger: "blur",
          },
          { validator: validateReceiver, trigger: "blur" },
        ],
        telNum: [
          { validator: validateTelNum, trigger: "blur" },
          {
            min: 3,
            max: 11,
            message: this.$l("长度在 3 到 11 个字符"),
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 100,
            message: this.$l("长度不能超过 200 个字符"),
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      bindDialogVisible: false,
      loading: false,
      selectedList: [],
      elevator: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      isBindElevator: false,
      bindElevatorLoading: false,
      tableElevatorData: [],
      elevatorForm: {
        pageNum: 1,
        pageSize: 10,
        pageName: "",
        domainName: "",
        jobNum: "",
      },
      jobNumList: [],
      isLoadElevator: false,
      importElevatorDialogVisible: false,
      fileList: [],
      file: null,
      fullLoading: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      if (this.isBindElevator) {
        this.elevator.pageSize = val;
        this.initElevatorData();
      } else {
        this.pageConfig.pageSize = val;
        this.initData();
      }
    },
    handleCurrentPageChange(val) {
      if (this.isBindElevator) {
        this.elevator.currentPage = val;
        this.initElevatorData();
      } else {
        this.pageConfig.currentPage = val;
        this.initData();
      }
    },
    showAdd() {
      this.editDialogTitle = "新建短信接收人";
      this.editDialogVisible = true;
      this.editForm.receiverId = null;
      this.editForm.receiver = "";
      this.editForm.telNum = "";
      this.editForm.remark = "";
      this.editForm.jobNumList = null;
      this.jobNumList = [];
      this.elevator.currentPage = 1;
      this.elevator.pageSize = 10;
      this.elevatorForm.domainName = "";
      this.elevatorForm.jobNum = "";
      this.isLoadElevator = true;
    },
    showEdit(row) {
      this.editDialogTitle = "编辑短信接收人";
      this.editDialogVisible = true;
      if (this.editForm.receiverId == row.receiverId) {
        this.isLoadElevator = false;
        return;
      }
      this.isLoadElevator = true;
      this.jobNumList = [];
      this.elevator.currentPage = 1;
      this.elevator.pageSize = 10;
      this.elevatorForm.domainName = "";
      this.elevatorForm.jobNum = "";
      this.editForm.receiverId = row.receiverId;
      this.$http
        .get(this.$apiConfig.get_sms_receiver_url + row.receiverId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = result.data[key];
            }
            this.jobNumList = JSON.parse(
              JSON.stringify(this.editForm.jobNumList)
            );
            this.editForm.jobNumList = null;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_sms_receiver_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_sms_receiver_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteReceiver() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].receiverId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_sms_receiver_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
    showBindElevator() {
      this.bindDialogVisible = true;
      this.isBindElevator = true;
      if (this.isLoadElevator) {
        this.isLoadElevator = false;
        this.initElevatorData();
      }
    },
    bindElevator() {
      this.editForm.jobNumList = JSON.parse(JSON.stringify(this.jobNumList));
      this.bindDialogVisible = false;
      this.isBindElevator = false;
    },
    initElevatorData() {
      this.elevatorForm.pageNum = this.elevator.currentPage;
      this.elevatorForm.pageSize = this.elevator.pageSize;
      this.elevatorForm.pageName = "lift";
      this.tableElevatorData = [];
      this.bindElevatorLoading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_url, this.elevatorForm)
        .then((response) => {
          this.bindElevatorLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.elevator.total = result.data.total;
            this.tableElevatorData = result.data.result;
            this.$nextTick(() => {
              this.tableElevatorData.forEach((row, i) => {
                if (
                  this.jobNumList.filter((v) => v == row.jobNum).length == 1
                ) {
                  this.$refs.elevatorTable.toggleRowSelection(row, true);
                }
              });
            });
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.bindElevatorLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    searchElevator() {
      this.elevator.currentPage = 1;
      this.initElevatorData();
    },
    selectElevator(selection, row) {
      let flag = false;
      selection.forEach((item, i) => {
        if (this.jobNumList.filter((v) => v == item.jobNum).length == 0) {
          this.jobNumList.push(item.jobNum);
        }
        if (!flag && item.jobNum == row.jobNum) {
          flag = true;
        }
      });
      if (!flag) {
        flag = false;
        let index = -1;
        this.jobNumList.forEach((v, i) => {
          if (v == row.jobNum) {
            flag = true;
            index = i;
          }
        });
        if (flag) {
          this.jobNumList.splice(index, 1);
        }
      }
    },
    selectAllElevator(selection) {
      if (selection.length > 0) {
        selection.forEach((item, i) => {
          if (this.jobNumList.filter((v) => v == item.jobNum).length == 0) {
            this.jobNumList.push(item.jobNum);
          }
        });
      } else {
        let indexs = [];
        this.jobNumList.forEach((v, i) => {
          if (this.tableElevatorData.filter((t) => t.jobNum == v).length == 1) {
            indexs.push(i);
          }
        });
        if (indexs.length > 0) {
          let temp = 0;
          for (let i = 0; i < indexs.length; i++) {
            this.jobNumList.splice(indexs[i] - temp, 1);
            temp++;
          }
        }
      }
    },
    clearSelectedElevator() {
      this.jobNumList = [];
      this.tableElevatorData.forEach((row, i) => {
        this.$refs.elevatorTable.toggleRowSelection(row, false);
      });
    },
    cancelBindElevator() {
      this.editForm.jobNumList = null;
      this.bindDialogVisible = false;
    },
    closeBindElevatorDialog() {
      this.isBindElevator = false;
    },
    closeTag(val) {
      let index = -1;
      this.jobNumList.forEach((v, i) => {
        if (v == val) {
          this.tableElevatorData.forEach((row, ii) => {
            if (v == row.jobNum) {
              this.$refs.elevatorTable.toggleRowSelection(row, false);
            }
          });
          index = i;
        }
      });
      if (index >= 0) {
        this.jobNumList.splice(index, 1);
      }
    },
    openImportElevator() {
      this.fileList = [];
      this.file = null;
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择短信接收人");
        return;
      }
      if (len > 1) {
        this.message(1, "请选择一个短信接收人");
        return;
      }
      this.importElevatorDialogVisible = true;
    },
    onFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
      this.file = file.raw;
    },
    onFileRemove() {
      this.file = null;
    },
    importElevator() {
      if (this.file == null) {
        this.message(1, "请选择要上传的文件");
        return;
      }
      if (!this.file.name.endsWith(".xlsx")) {
        this.message(1, "文件类型错误，请选择类型为xlsx的文件");
        return;
      }
      this.fullLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      const receiver = this.selectedList[0];
      formData.append("receiverId", receiver.receiverId);
      this.$http
        .post(
          this.$apiConfig.sms_receiver_import_elevator_permission_url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          let data = result.data;
          if (result.code == 0) {
            this.message(result.code, result.msg);
            this.importElevatorDialogVisible = false;
            this.editForm.jobNumList = null;
            this.editForm.receiverId = null;
          } else if (data) {
            let html =
              '<div style="height:400px;word-wrap: break-word;overflow:auto;">';
            if (data.notJobNumList.length > 0) {
              html +=
                '<span style="color:blue">不在当前用户权限范围内的电梯工号：</span><br/>' +
                data.notJobNumList.join(",") +
                "<br/>";
            }
            if (data.addFailureJobNumList.length > 0) {
              html +=
                '<span style="color:blue">导入失败的电梯工号：</span><br/>' +
                data.addFailureJobNumList.join(",");
            }
            html += "</div>";
            this.$alert(html, "提示", {
              dangerouslyUseHTMLString: true,
            });
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    downloadTemplate(fileName) {
      this.$http({
        url: this.$apiConfig.download_template_url + "?fileName=" + fileName,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          const status = response.status;
          if (status != 200) {
            this.message(1, "下载失败");
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = fileName;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.receiver {
  .dialog-form {
    .el-input {
      width: 400px;
    }
    .el-textarea {
      width: 400px;
    }
  }
  .bindElevator {
    /deep/ .el-dialog__body {
      padding: 10px 20px 20px 20px;
    }
  }
  .selectedElevator {
    max-height: 100px;
    overflow: auto;
    span {
      display: inline-block;
      margin-bottom: 4px;
      margin-right: 4px;
    }
  }
}
</style>
